// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","screenReaderOnly":"styles_screenReaderOnly__ekG0L"};